import type { FC } from 'react';
import { PlayCircleOutline } from '@eqi-investimentos/icons/web';
import { Button, Text } from '@eqi-investimentos/react';
import { useT } from '@/libs/i18n/utils/useT';

export const VideoModeButton: FC<VideoModeButtonProps> = ({ onClick }) => {
  const t = useT();

  return (
    <Button
      aria-label={t('attributes.videoMode')}
      rightIcon={<PlayCircleOutline />}
      gap="2xs"
      alignItems="center"
      h="1.25rem"
      size="lg"
      fontWeight="semibold"
      variant="naked"
      color="content.brand"
      onClick={onClick}
    >
      <Text size="label.xl" fontWeight="semibold">
        {t('attributes.videoMode')}
      </Text>
    </Button>
  );
};

export type VideoModeButtonProps = {
  onClick: () => void;
};
